import { Pipe, PipeTransform } from '@angular/core';

/** Gives back values that contains the searched string */

@Pipe({
  name: 'search',
  standalone: false
})
export class SearchPipe implements PipeTransform {

  /** Comparing input values to searched string */
  public transform(stringList: string[], searchValue: string) {

    if (!searchValue) return stringList;
    return (stringList || []).filter((item: string) => item.includes(searchValue));

  }
}
